export const getDistance = (userLocation, sculptureLocation) => {
  const a = userLocation[0] - sculptureLocation[0];
  const b = userLocation[2] - sculptureLocation[2];
  return Math.sqrt(a ** 2 + b ** 2);
};
